export const DOCTOR_INFO_REFRESH_EVENT = 'doctorInfoRefresh';

/**
 * Dispatch a global browser event to notify interested listeners (e.g. DoctorInfoContext)
 * that doctor information on the backend might have changed and should be refreshed.
 */
export function triggerDoctorInfoRefresh() {
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new Event(DOCTOR_INFO_REFRESH_EVENT));
  }
}

// Legacy aliases for backward compatibility - will be removed
export const USER_INFO_REFRESH_EVENT = DOCTOR_INFO_REFRESH_EVENT;
export const triggerUserInfoRefresh = triggerDoctorInfoRefresh; 